import { useCallback, useEffect, useState } from "react"

import { Input, InputGroup, InputGroupText, DefaultTable } from "twyne-new.ui"

import { PureSwitch } from "@Components/form/Switch"
import { useSettingStore } from "@Modules/cms/views/setting/store"

function useWildcard({ fetchSiteSettings, onChange } = {}) {
  const [aliases, setAliases] = useState([])
  const [wildCards, setWildcards] = useState({})

  const parseDomains = useCallback(async () => {
    const aliases = []
    const wildCards = {}
    const { domain_aliases } = await fetchSiteSettings()
    domain_aliases.split(',').forEach(alias => {
      const aliasPerse = JSON.parse(alias)
      if (aliasPerse.includes('*.')) {
        wildCards[aliasPerse.replace('*.', '')] = true
        return
      }

      aliases.push({
        alias: aliasPerse,
      })
    })

    setAliases(aliases)
    setWildcards(wildCards)
  }, [fetchSiteSettings])

  useEffect(() => {
    parseDomains()
  }, [parseDomains])

  const handleChangeWildcard = index => ({ target: { checked } }) => {
    setWildcards(prevState => {
      prevState[aliases[index]?.alias] = checked

      if (!checked) delete prevState[aliases[index]?.alias]

      const wildCardAlaises = Object.keys(prevState).map(domain => JSON.stringify(`*.${domain}`))
      onChange(aliases.map(({ alias }) => JSON.stringify(alias)).concat(wildCardAlaises).join())

      return {
        ...prevState,
      }
    })
  }

  return {
    wildCards,
    aliases,
    getWildcardEnabled: index => wildCards[aliases[index].alias] || false,
    handleChangeWildcard,
  }
}

const AliasInput = ({ value }) => <InputGroup>
  <InputGroupText>https://</InputGroupText>
  <Input
    value={value}
    disabled
  />
</InputGroup>

export default function WildcardComponent({ onChange, value }) {
  const { fetchSiteSettings } = useSettingStore()
  const { aliases, handleChangeWildcard, getWildcardEnabled } = useWildcard({ fetchSiteSettings, value, onChange })
  const columns = [{
    dataField: 'alias',
    text: 'Domain Aliases',
    formatter: (col, row, index) => <AliasInput key={index} value={col} />,
  }, {
    dataField: 'actions',
    text: 'Enabled',
    formatter: (_, row, index) => <div key={`actions-2-${index}`}>
      <PureSwitch onChange={handleChangeWildcard(index)} value={getWildcardEnabled(index)} />
    </div>,
  }]

  return <DefaultTable
    data={aliases}
    columns={columns}
  />
}
